import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//components
import Pickup from "./Pickup";
import CheckoutFooter from "./CheckoutFooter";

//styles
import "./Fulfillment.css";
import "./Pickup.css";

//custom hooks
import { useRoute } from "../../hooks/useRoute";
import { useCart } from "../../hooks/useCart";
import { useAuthContext } from "../../hooks/useAuthContext";
import getAuthHeaders from "../../utils/getAuthHeaders";
import reportError from "../../utils/reportError";

export default function PickupOnly() {
  const [fulfillmentObject, setFulfillmentObject] = useState({});
  const [disableContinue, setDisableContinue] = useState(true);

  const navigate = useNavigate();
  const { cart, cartTotal, updateCart } = useCart();
  const { route, setRoute } = useRoute();
  const { user } = useAuthContext();

  useEffect(() => {
    if (user) {
      const getLocation = async () => {
        try {
          const authHeader = await getAuthHeaders(user);

          let routeUrl = `/api/routes/`;

          if (process.env.NODE_ENV === "development") {
            routeUrl = `${process.env.REACT_APP_NETWORK}${routeUrl}`;
          }

          fetch(routeUrl, { headers: authHeader }).then(async (res) => {
            const json = await res.json();
            setRoute(json);
          });
        } catch (err) {
          reportError(err, "fetch route in PickupOnly");
        }
      };

      getLocation();
    }
  }, []);

  const HandleCheckout = () => {
    updateCart("FULFILLMENT_INFO", fulfillmentObject);
    navigate("/cart/checkout", { replace: true });
  };

  return (
    <div>
      <div className="fulfillment">
        <Pickup
          setDisableContinue={setDisableContinue}
          setFulfillmentObject={setFulfillmentObject}
          route={route}
        />
      </div>
      <CheckoutFooter
        cart={cart}
        cartTotal={cartTotal}
        clickAction={HandleCheckout}
        text={"Continue"}
        disabled={disableContinue}
      />
    </div>
  );
}
